import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, ListItemSecondaryAction } from "@mui/material";
import { useNotification } from "app/NotificationProvider";
import { AnalyticsEvents, analytics } from "common/analytics";
import { useTranslation } from "common/locales";
import { ManualDMInputResponse } from "model";
import { useUpdateReading } from "model/useReadingMutations";

export default function FieldEventConfirmationMenu({
  machineInput,
  children,
}: {
  machineInput: ManualDMInputResponse;
  children?: React.ReactNode;
}) {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const updateReading = useUpdateReading();
  return (
    <ListItemSecondaryAction>
      <IconButton
        edge="end"
        onClick={() => handleAcceptMachineReading(machineInput)}
        aria-label={t("fieldevents.menu.accept")}
        size="large"
      >
        <CheckIcon />
      </IconButton>
      <IconButton
        edge="end"
        onClick={() => handleRejectMachineReading(machineInput)}
        aria-label={t("fieldevents.menu.reject")}
        size="large"
      >
        <ClearIcon />
      </IconButton>
      {children}
    </ListItemSecondaryAction>
  );
  function handleAcceptMachineReading(reading: ManualDMInputResponse) {
    updateReading.mutate(
      {
        ...reading,
        manualDryMatterInput: {
          ...reading.manualDryMatterInput,
          verificationStatus: "Accepted",
        },
      },
      {
        onSuccess: () => {
          notify(t("fieldevents.notify.accepted"));
          analytics.track(AnalyticsEvents.AUTODETECTED_EVENT_ACCEPTED);
        },
      }
    );
  }
  function handleRejectMachineReading(reading: ManualDMInputResponse) {
    updateReading.mutate(
      {
        ...reading,
        manualDryMatterInput: {
          ...reading.manualDryMatterInput,
          verificationStatus: "Rejected",
        },
      },
      {
        onSuccess: () => {
          notify(t("fieldevents.notify.rejected"));
          analytics.track(AnalyticsEvents.AUTODETECTED_EVENT_REJECTED);
        },
      }
    );
  }
}
